import React, { useState } from "react";
import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import { Field, Formik } from "formik";
import DatePicker from "react-datepicker";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import moment from "moment";
import ReactInputMask from "react-input-mask";
import Calendar from "assets/icon/calendar-pms.svg";
import admin from "assets/icon/admin-black.svg";
import patientDate from "assets/icon/paitent-date.svg";
import changePatientIcon from "assets/icon/change-patient-icon.svg";

const SearchContainer = () => {
  const [startDate, setStartdate] = useState(null);
  const [focusedInput, setFocusedInput] = useState("");
  const [addInputBox, setAddInputBox] = useState("");
  const [value, setValue]=useState("Doe, John")

  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleBlur = () => {
    setFocusedInput("");
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };
  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };
  const addInputBoxHandler = () => {
    setAddInputBox(!addInputBox);
  };
  return (
    <Row className="mb-8">
      {addInputBox ? (
       <Row>
       <Col sm={12} md={5}>
         <FormGroup className="controls">
           <InputGroup className="order-entry-search">
               <img src={admin}  className="search-patient-input" />
             <Input
               id="reportname"
               name="reportname"
               type="text"
               placeholder="Search by Patient Name"
               autoComplete="off"
               className="input-spacing-left"
               value={value}
               onChange={(e)=>setValue(e.target.value)}

             ></Input>
           </InputGroup>
         </FormGroup>
       </Col>
       <Col sm={12} md={5} className="required-date1 mb-2">
         <InputGroup
           onMouseLeave={handleMouseLeave}
           className="remove-outline  order-entry-search "
           
         >               
           <img src={patientDate}  className="img-patient" />
            <DatePicker
             id="startDate"
             name="startDate"
             selected={startDate}
             onChange={(startDate) => handleStartDate(startDate)}
             onFocus={() => handleFocus("StartDate")}
             onBlur={handleBlur}
             isClearable
             onChangeRaw={handleStartDateRaw}
             dateFormat="MM/dd/yyyy"
             placeholderText="MM/DD/YYYY"
             autoComplete="off"
             className="input-spacing-left"

             customInput={
               <ReactInputMask mask="99/99/9999" value={startDate} />
             }
           />
           <InputGroupText className="date-img" onClick={() => handleDateClick("startDate")}>
             <img src={Calendar} alt="" />
           </InputGroupText>
         </InputGroup>
       </Col>
       <Col
         sm={12}
         md={2}
         className="mb-2"
         style={{ display: "flex", justifyContent: "end" }}
       >
         <Button
         
           color="primary"
           className="search"
           onClick={addInputBoxHandler}
         >
           {addInputBox ? "Change Patients" : "Search"}
         </Button>
       </Col>
     </Row>
      ) : (
        <Row>
           <Col style={{width:"auto"}}>
                        <FormGroup className="controls">
                          <InputGroup className="order-entry-search">
                           
                              <img src={admin} className="search-patient-input" />
                            <Input
                              id="reportname"
                              name="reportname"
                              type="text"
                              placeholder="John"
                              autoComplete="off"
                              value={value}

                              className="input-spacing-left p-input"
                            ></Input>
                          </InputGroup>
                        </FormGroup>
                      </Col>
          <Col sm={2}>
            <Button
              color="primary"
              className="search"
              onClick={addInputBoxHandler}
            >
              {addInputBox ? (
                "Search"
              ) : (
                <div>
                  <img src={changePatientIcon} /> Change Patients
                </div>
              )}
            </Button>
          </Col>
        </Row>
      )}

    
    </Row>
  );
};

export default SearchContainer;
